import React, { ComponentProps } from 'react'
import Caption from '../Typography/Caption'
import styled from 'styled-components'
import { rem } from 'polished'
import { _TextBlockIcon, TextBlockProps, _TextBlockStyle } from './_TextBlock'
import cn from 'clsx'

const TextBlock = styled(Caption)`
  ${_TextBlockStyle}

  &.variant-large,
  &.variant-medium,
  &.variant-small {
    --text-block-gap: ${rem(4)};
  }
`

interface Props extends Omit<ComponentProps<typeof Caption>, 'as' | 'forwardedAs'>, TextBlockProps {
}

function CaptionTextBlock(props: Props) {
  const {
    children,
    endIcon = null,
    startIcon = null,
    fit,
    align,
    tabletAlign,
    variant,
    className,
    format,
    lineClamp,
    wrap,
    ...rest
  } = props

  return <TextBlock
    {...rest}
    variant={variant}
    className={cn(
      className,
      fit ? `fit-${fit}` : undefined,
      align ? `align-${align}` : undefined,
      tabletAlign ? `align-on-tablet-${tabletAlign}` : undefined,
    )}
  >
    {!!startIcon && <_TextBlockIcon>{startIcon}</_TextBlockIcon>}
    <Caption
      variant={variant}
      format={format}
      lineClamp={lineClamp}
      wrap={wrap}
      align={align}
      tabletAlign={tabletAlign}
    >
      {children}
    </Caption>
    {!!endIcon && <_TextBlockIcon>{endIcon}</_TextBlockIcon>}
  </TextBlock>
}

export default CaptionTextBlock
